export const LOAD_DRIVER_ACTIVITY = 'LOAD_DRIVER_ACTIVITY';
export const GET_DRIVER_ACTIVITY = 'GET_DRIVER_ACTIVITY';
export const CLEAR_DRIVER_ACTIVITY = 'CLEAR_DRIVER_ACTIVITY';